import React, { useEffect, useState } from "react";
import InnerLayout from "../../../components/layouts/inner-layout";
import LoadingSpinner from "../../../components/helper-components/loading-spinner";
import { useDispatch } from "react-redux";
import { useParams, useSearchParams } from "react-router-dom";
import { salesDeliveryViewAction } from "../../../redux/actions/sales-action";
import CreateEditViewSalesDelivery from "../../../components/sales-section/delivery-section/create-edit-view-sales-delivery";
const EditDelivery = () => {
  const { id } = useParams();
  const [orderDetail, setOrderDetail] = useState({});
  const [loading, setLoading] = useState(true);
  const dispatch = useDispatch();
  useEffect(() => {
    setLoading(true);
    dispatch(salesDeliveryViewAction(id, onSuccPur, onErrPur));
  }, []);

  const onSuccPur = (data) => {
    setOrderDetail(data?.data?.[0]);
    setLoading(false);
  };

  const onErrPur = (data) => {
    setLoading(false);
  };
  console.log(
    orderDetail?.orderData?.sodtt_order_status,
    "fgdgdfgfdgdfgfdgdfgdg"
  );

  const [searchParams] = useSearchParams();
  const isNew = searchParams.has("new");

  return (
    <>
      {loading ? (
        <LoadingSpinner />
      ) : (
        <InnerLayout backBtn={true} title="Edit Delivery">
          <CreateEditViewSalesDelivery
            clickedplus={isNew}
            page="edit"
            pageType="delivary"
            standAlone={true}
            payto={orderDetail?.orderData?.sodtt_pay_to_address}
            shipto={orderDetail?.orderData?.sodtt_ship_to_address}
            disabled={
              true && orderDetail?.orderData?.sodtt_order_status !== "draft"
            }
            orderDetail={orderDetail?.itemData}
            vendorDetails={[orderDetail?.orderData]}
          />
        </InnerLayout>
      )}
    </>
  );
};
export default EditDelivery;
